<template>
  <div class="portfolio service-portlet" id="portfolio-section" >

    <!-- Container -->
    <div class="container">
      <!-- Portfolio Filters -->
      <div class="header-text" v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '30px' }">
        <div class="liststyle margin"></div>
        <div class="portfolio-menu-wrap">
          <ul id="filters" class="portfolio-menu">

<!--
            <li><a data-filter="*" class="active" href="#">모두보기</a></li>
            <li><a data-filter=".mobile" href="#">모바일 어플리케이션</a></li>
            <li><a data-filter=".pc" href="#">PC 어플리케이션</a></li>
            <li><a data-filter=".web" href="#">웹 프로그래밍</a></li>
        -->

                        <li><a v-bind:class="{ active: showMode == 0 }" v-on:click="showMode=0">모두보기</a></li>
                        <li><a v-bind:class="{ active: showMode == 1 }" v-on:click="showMode=1">모바일 어플리케이션</a></li>
                        <li><a v-bind:class="{ active: showMode == 2 }" v-on:click="showMode=2">PC 어플리케이션</a></li>
                        <li><a v-bind:class="{ active: showMode == 3 }" v-on:click="showMode=3">웹 프로그래밍</a></li>



                      </ul><!-- / Portfolio Filters -->
        </div>
      </div>
      <!--<button onclick="window.open('https://play.google.com/store/apps/details?id=com.hamsoa.mobile')">button</button>-->
      <ul id="lightgallery" class="portfolio-list" v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '30px' }">
        <li class="four columns" data-src="static/images/portfolio/portfolio_ls.jpg"
            data-sub-html="<h6>LS산전 [Smart Support]</h6>
                <p>
                스마트 폰 또는 태블릿 기기를 이용하여 PLC의 상태를 모니터링 할 수 있는 애플리케이션으로 모바일을 통해 쉽게 PLC상태를 확인
                <br><span>모바일 어플리케이션</span>
                </p>"
            v-show="showMode==0 || showMode ==1">
          <!--<li class="four columns mobile" data-src="http://vimeo.com/1084537" data-poster="static/images/portfolio_thumbnail_bugo.JPG" data-sub-html="<h6>Instagram</h6><p>Classic view from Rigwood Jetty on Coniston Water an old archive shot similar to an old post but a little later on.</p>">-->
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_ls.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">LS산전 [Smart Support]</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_hamsoa.jpg"
            data-sub-html="<h6>함소아 한의원 공식 어플리케이션</h6>
                <p>
                함소아에서 사용하는 공식 어플리케이션으로 고객들은 위한 모바일 어플리케이션, 병원과 한의사들을 위한 패드용 어플리케이션 제작
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.hamsoa.mobile')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/us/app/%ED%95%A8%EC%86%8C%EC%95%84/id984501320?mt=8')&quot;></button></li>
                 </ul>
                </p>" v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_hamsoa.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">함소아 한의원 공식 어플리케이션</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns pc" data-src="static/images/portfolio/portfolio_oled.jpg"
            data-sub-html="<h6>이러닝 강의를 위한 멀티채널 플레이어& 영상편집기</h6>
                <p>
                영상 기반의 이러닝 컨텐츠 저작 도구로 교수자 및 학습자가 콘텐츠 개발을 쉽게 제작할 수 있도록 저작 시스템 기능 구축
                <br><span>PC 어플리케이션</span>
                </p>"  v-show="showMode==0 || showMode ==2">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_oled.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">이러닝 강의를 위한 멀티채널 플레이어& 영상편집기</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_focustimer.jpg"
            data-sub-html="<h6>방치의신 : 집중력 향상, 방치시간 타이머</h6>
                <p>
                스마트폰을 사용하지 않는 시간을 측정하고 방치한 시간만큼 포인트로 보상해주는 서비스
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.rena.focustimer&hl=ko')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/%EB%B0%A9%EC%B9%98%EC%9D%98-%EC%8B%A0-%EB%B3%B4%EC%83%81%ED%98%95-%EC%A7%91%EC%A4%91%EB%A0%A5-%ED%96%A5%EC%83%81-%EC%96%B4%ED%94%8C/id1236633080?mt=8')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_focustimer.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">방치의신 : 집중력 향상, 방치시간 타이머</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>

        <li class="four columns web" data-src="static/images/portfolio/portfolio_oled_2.jpg"
            data-sub-html="<h6>코리아텍 온라인평생교육원 학습자평가시스템 구축</h6>
                <p>
                영상 기반의 이러닝 컨텐츠 저작 도구로 교수자 및 학습자가 콘텐츠 개발을 쉽게 제작할 수 있도록 저작 시스템 기능 구축
                 <br><span>웹</span>
                </p>"  v-show="showMode==0 || showMode ==3">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_oled_2.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">코리아텍 온라인평생교육원 학습자평가시스템 구축</p>
            <p class="list-filter">웹</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_koreatech.jpg"
            data-sub-html="<h6>코리아텍 다담-e : 한국기술교육대학교 공식 앱</h6>
                <p>
                재학생들의 편리한 학교생활을 위해 제작된 한국기술교육대학교 공식 어플리케이션
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=kr.ac.koreatech.life&hl=ko')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/%EC%BD%94%EB%A6%AC%EC%95%84%ED%85%8D-%EB%8B%A4%EB%8B%B4-e/id1205132559?mt=8')&quot;></button></li>
                 </ul>
                </p>" v-show="showMode==0 || showMode ==1">                <a href="">
          <div class="portfolio-box">
            <a class="" href="#" title="">
              <img  src="static/images/portfolio/portfolio_thumbnail_koreatech.JPG" alt="" />
              <div class="mask"></div>
            </a>
          </div>
          <p class="list-title">코리아텍 다담-e : 한국기술교육대학교 공식 앱</p>
          <p class="list-filter">모바일 어플리케이션</p>
        </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_shes.jpg"
            data-sub-html="<h6>쉬즈한의원</h6>
                <p>
                쉬즈한의원 공식 앱으로 건강관리, 차트내역, 쉬즈한의원 소식 등 다양한 기능 제공
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.shes.mobile')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/shes%ED%95%9C%EC%9D%98%EC%9B%90-%EC%89%AC%EC%A6%88/id1136066546?mt=8')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_shes.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">쉬즈한의원</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_snapmovie.jpg"
            data-sub-html="<h6>스냅무비 : 동영상 촬영 및 제작 앱</h6>
                <p>
                다양한 공간에서 선택한 시간(1초~6초)까지 영상을 촬영하고 각 촬영한 영상을 한편에 영화같이 인코딩해주는 어플리케이션
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=net.rena.roadmovie.lite&hl=ko')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_snapmovie.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">스냅무비 : 동영상 촬영 및 제작 앱</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>

        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_korail.jpg"
            data-sub-html="<h6>코레일 브러시 압력 측정기</h6>
                <p>
                블루투스를 이용하여 브러시 압력 측정값을 표시
                 <br><span>모바일 어플리케이션</span>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_korail.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">코레일 브러시 압력 측정기</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns pc" data-src="static/images/portfolio/portfolio_haneul.jpg"
            data-sub-html="<h6>하늘 장례식장 관리 및 빈소 안내 시스템</h6>
                <p>
                장례식장 관리 프로그램과 빈소 안내 모니터로 구성된 시스템으로 장례식당을 보다 간편하고 체계적으로 관리할 수 있도록 구성된 서비스
                 <br><span>PC 어플리케이션</span>
                 <ul>
                 <li class=&quot;www&quot;><button onclick=&quot;window.open('http://haneul.renasoftware.com/')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==2">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_haneul.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">하늘 장례식장 관리 및 빈소 안내 시스템</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_bugo.jpg"
            data-sub-html="<h6>모바일 부고장 하늘 부고</h6>
                <p>
               감자기 상으로 경황이 없을 때 지인들에게 신속하고 정중하게 모바일 부고장을 보내는 서비스
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.rena.obituary')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/%ED%95%98%EB%8A%98-%EB%B6%80%EA%B3%A0/id1130280017?mt=8')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_bugo.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">모바일 부고장 하늘 부고</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_문상짱껜뽀.JPG"
            data-sub-html="<h6>문상짱껜뽀 : 리워드 서비스</h6>
                <p>
                리워드 어플리케이션으로 광고, 미션 참여, 랭킹, 추억의 짱껜뽀 게임 등의 기능으로 구성
                 <br><span>모바일 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.rena.reward')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/%EB%AC%B8%EC%83%81%EC%A7%B1%EA%BB%9C%EB%BD%80/id1144833347?mt=8')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_문상짱껜뽀.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">문상짱껜뽀 : 리워드 서비스</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>

        <li class="four columns pc" data-src="https://youtu.be/5Z9_nbjTl2E"
            data-sub-html="<h6>ETRI  ‘CPS Visualizer’</h6>
                <p>
                분산 실시간 시뮬레이션 3D 시각화 소프트웨어로서, 분산 환경에서 원격지에 있는 시뮬레이터와 데이터를 송/수신하여 시뮬레이션 결과를 3D로 시각화하고,
                주변 환경 및 각종 효과를 표현하여 다양한 Viewpoint로 시뮬레이션을 확인할 수 있도록 하는 소프트웨어
                 <br><span>PC 어플리케이션</span>
                </p>"  v-show="showMode==0 || showMode ==2">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_etri.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">ETRI  ‘CPS Visualizer’</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns pc" data-src="https://youtu.be/ZRA8eCpVKCw"
            data-sub-html="<h6>솔라 해석 프로그램</h6>
                <p>

                 <br><span>PC 어플리케이션</span>
                </p>"  v-show="showMode==0 || showMode ==2">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_solar.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">솔라 해석 프로그램</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile pc" data-src="https://youtu.be/6ms5FpziJ00"
            data-sub-html="<h6>강의스케치</h6>
                <p>
                 강의자 및 발표자를 위한 실시간 화면 동기화 서비스
                 <br><span>모바일 어플리케이션</span><span>PC 어플리케이션</span>
                </p>"  v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_lectureSketch.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">강의스케치</p>
            <p class="list-filter">모바일, PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile pc" data-src="static/images/portfolio/portfolio_slivergun.jpg"
            data-sub-html="<h6>실버건 : 번역서비스</h6>
                <p>
                카메라를 사용하여 언어 실시간 번역, PC화면 실시간 번역
                 <br><span>모바일 어플리케이션</span><span>PC 어플리케이션</span>
                 <ul>
                 <li><button onclick=&quot;window.open('https://play.google.com/store/apps/details?id=com.rena.transcam&hl=ko')&quot;></button></li>
                 <li><button onclick=&quot;window.open('https://itunes.apple.com/kr/app/%EC%8B%A4%EB%B2%84%EA%B1%B4/id1214322749?mt=8')&quot;></button></li>
                 </ul>
                </p>"  v-show="showMode==0 || showMode ==1 || showMode==2">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_slivergun.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">실버건 : 번역서비스</p>
            <p class="list-filter">모바일, PC 어플리케이션</p>
          </a>
        </li>

        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_something.jpg"
            data-sub-html="<h6>썸씽 : 프리미엄 데이팅 어플리케이션</h6>
                <p>
                솔로인 미혼남녀를 위한 소개팅 어플리케이션
                 <br><span>모바일 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==1">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_something.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">썸씽 : 프리미엄 데이팅 어플리케이션</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile web" data-src="static/images/portfolio/portfolio_airrental.jpg"
            data-sub-html="<h6>에어렌탈 : 쉐어링 서비스</h6>
                <p>
                사용자들끼리 자신의 직접 물건을 쉐어링하는 서비스
                 <br><span>모바일 어플리케이션</span><span>웹</span>
                </p>" v-show="showMode==0 || showMode ==1 || showMode ==3 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_airrental.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">에어렌탈 : 쉐어링 서비스</p>
            <p class="list-filter">모바일 어플리케이션, 웹</p>
          </a>
        </li>
        <li class="four columns web" data-src="static/images/portfolio/portfolio_lectureSketchWeb.jpg"
            data-sub-html="<h6>강의스케치 웹사이트</h6>
                <p>
                 <br><span>웹</span>
                </p>" v-show="showMode==0 || showMode ==3 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_lectureSketchWeb.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">강의스케치 웹사이트</p>
            <p class="list-filter">웹</p>
          </a>
        </li>
        <li class="four columns mobile" data-src="static/images/portfolio/portfolio_musicon.jpg"
            data-sub-html="<h6>뮤직온 : Youtube mesh up 음악 스트리밍 서비스</h6>
                <p>
                Youtube MeshUP Service를 기반으로 유투브 영상을 재생시켜 무료로 음악을 들을 수 있는 서비스로 2013년에 출시하여 100만 다운로드 달성
                 <br><span>모바일 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==1 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_musicon.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">뮤직온 : Youtube mesh up 음악 스트리밍 서비스</p>
            <p class="list-filter">모바일 어플리케이션</p>
          </a>
        </li>

        <li class="four columns pc" data-src="static/images/portfolio/portfolio_nass.jpg"
            data-sub-html="<h6>선박, 소중 방사 소음 해석 프로그램</h6>
                <p>
                선박의 소음원을 기반으로 방음효과에 따른 객실내의 소음을 해석
                 <br><span>PC 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==2  ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_nass.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">선박, 소중 방사 소음 해석 프로그램</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns pc" data-src="static/images/portfolio/portfolio_현대.jpg"
            data-sub-html="<h6>고속철도 소음 시뮬레이션</h6>
                <p>
                 <br><span>PC 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==2 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_현대.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">고속철도 소음 시뮬레이션</p>
            <p class="list-filter">PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns web pc" data-src="static/images/portfolio/portfolio_hanium.jpg"
            data-sub-html="<h6>한이음 : 프로젝트, 업무 관리 시스템</h6>
                <p>
                프로젝트, 업무, 데이터 모두를 관리하는 종학적인 프로젝트 관리 솔루션
                 <br><span>웹</span><span>PC 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==2 || showMode ==3 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_hanium.JPG" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">한이음 : 프로젝트, 업무 관리 시스템</p>
            <p class="list-filter">웹, PC 어플리케이션</p>
          </a>
        </li>
        <li class="four columns mobile pc" data-src="static/images/portfolio/portfolio_memoit.jpg"
            data-sub-html="<h6>메모잇 : 메모 관리 서비</h6>
                <p>
               PC, 모바일에서 텍스트, 이미지, 오디오, 영상, 체크리스트 형식으로 메모를 기록하고 실시간으로 동기화되는 메모 관리 서비스
                 <br><span>모바일 어플리케이션</span><span>PC 어플리케이션</span>
                </p>" v-show="showMode==0 || showMode ==1 || showMode ==2 ">
          <a href="">
            <div class="portfolio-box">
              <a class="" href="#" title="">
                <img  src="static/images/portfolio/portfolio_thumbnail_memoit.jpg" alt="" />
                <div class="mask"></div>
              </a>
            </div>
            <p class="list-title">메모잇 : 메모 관리 서비스</p>
            <p class="list-filter">모바일, PC 어플리케이션</p>
          </a>
        </li>

      </ul>
      <!--&lt;!&ndash; Ow Pagination &ndash;&gt;-->
      <!--<nav class="ow-pagination">-->
      <!--<ul class="pager">-->
      <!--<li class="active"><a href="#" title="">1</a></li>-->
      <!--<li><a href="#" title="">2</a></li>-->
      <!--<li><a href="#" title="">...</a></li>-->
      <!--<li><a href="#" title="">4</a></li>-->
      <!--<li class="next"><a href="#" title=""><i class="fa fa-angle-right"></i></a></li>-->
      <!--</ul>-->
      <!--</nav>&lt;!&ndash; Ow Pagination /- &ndash;&gt;-->

    </div><!-- Container /- -->



  </div><!-- Portfolio Section /- -->
</template>

<script>
  import 'lightgallery.js/dist/css/lightgallery.css'
  import 'lightgallery.js/dist/js/lightgallery'

  export default {
    name: 'Portfolio',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        showMode : 0 // 0:all 1,mobile, 2:pc , 3:web
      }
    },
    mounted() {
      lightGallery(document.getElementById('lightgallery'))
    },

    methods: {
      menuClick(title) {
        console.log('## click menu : ' + title)
        //this.menuVisible = false
        this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Portfolio.vue